import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'chassis-types',
    pluginName: 'SETTINGS',
    entityName: 'CHASSIS_TYPE',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch chassis types action creators
export const fetchChassisTypeInit = () => {
    return crudActions.fetchInit();
};
export const fetchChassisTypeStart = () => {
    return crudActions.fetchStart();
};
export const fetchChassisTypeSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchChassisTypeFail = () => {
    return crudActions.fetchFail();
};
export const fetchChassisTypeCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchChassisTypeStart());
        try {
            let countRes = await rest.post("chassis-types/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchChassisTypeSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchChassisTypeFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch chassis types."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchChassisTypeFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch chassis types."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchChassisType = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchChassisTypeStart());
        try {
            let listRes = await rest.post("chassis-types/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchChassisTypeSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchChassisTypeFail());
            return []

        } catch (error) {
            dispatch(fetchChassisTypeFail());
            return []
        }
    }
}

// Load chassis type action creators
export const loadChassisTypeInit = () => {
    return crudActions.loadInit();
};
export const loadChassisTypeStart = () => {
    return crudActions.loadStart();
};
export const loadChassisTypeSuccess = loadedChassisType => {
    return crudActions.loadSuccess(loadedChassisType);
};
export const loadChassisTypeFail = error => {
    return crudActions.loadFail(error);
};
export const loadChassisType = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

export const createChassisType = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/chassis-types/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created chassis type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create chassis type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const editChassisType = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/chassis-types/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated chassis type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit chassis type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Bulk delete chassis types action creators
export const bulkDeleteChassisTypesInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteChassisTypesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteChassisTypesSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteChassisTypesFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteChassisTypes = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteChassisTypesStart());
        try {
            let res = await rest.post('/chassis-types/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteChassisTypesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted chassis types.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteChassisTypesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete chassis types."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete chassis types."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteChassisTypesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Fetch chassis type values action creator (derived from the tenant's hardware subtypes)
export const fetchChassisTypeValues = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/hardware-subtype-keys/values', params);
            if (res.data && res.data.succeeded) {
                const values = [];
                const rows = Array.isArray(res.data.result.data) ? res.data.result.data : [];
                for (const row of rows) {
                    // the same TypeValue comes back once per hardware type: keep the first, in server order
                    if (row && row.TypeValue && !values.some(option => option.value === row.TypeValue)) {
                        values.push({ value: row.TypeValue, displayValue: row.TypeValue });
                    }
                }
                return values;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch chassis type values."}`,
                options: {
                    variant: 'warning'
                }
            });
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch chassis type values."}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};
